import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClose2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.1836 1.38574L6.31641 5.25293L10.1514 9.08789C10.4736 9.37793 10.4736 9.86133 10.1514 10.1514C9.86133 10.4736 9.37793 10.4736 9.08789 10.1514L5.2207 6.31641L1.38574 10.1514C1.0957 10.4736 0.612305 10.4736 0.322266 10.1514C0 9.86133 0 9.37793 0.322266 9.05566L4.15723 5.2207L0.322266 1.38574C0 1.0957 0 0.612305 0.322266 0.290039C0.612305 0 1.0957 0 1.41797 0.290039L5.25293 4.15723L9.08789 0.322266C9.37793 0 9.86133 0 10.1836 0.322266C10.4736 0.612305 10.4736 1.0957 10.1836 1.38574Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconClose2);
export { ForwardRef as ReactComponent };
